export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6568.76e92e7c.jpg";